// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"fill":"currentColor","d":"M8 4H16V1H18V4H22V9H2V4H6V1H8V4Z"},"nodeName":"path","children":[]},{"attributes":{"fill":"currentColor","d":"M22 10.9999V22H2V10.9999H22ZM18.5 14.5H14.5V18.5H18.5V14.5Z"},"nodeName":"path","children":[]}]};

@tag('t-icon-calendar-event-filled')
export default class CalendarEventFilledIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'calendar-event-filled',
    }
  }
}
